import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_slice } from '../../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../../_base/LOCAL__global_reset';
import { init_local_workspace_billing_balance_delete } from './local_workspace_billing_balance_delete';
import { init_local_workspace_billing_balance_upsert } from './local_workspace_billing_balance_upsert';
import { init_local_workspace_billing_credits_transactions_upsert } from './local_workspace_billing_credits_transactions_upsert';
import { init_workspace_local_billing_payment_transactions_upsert } from './local_workspace_billing_payment_transactions_upsert';
import { init_local_workspace_billing_subscriptions_delete } from './local_workspace_billing_subscriptions_delete';
import { init_local_billing_workspace_subscriptions_upsert } from './local_workspace_billing_subscriptions_upsert';
import { init_remote_stripe_checkout_session_create } from './remote_stripe_checkout_session_create';
import { StateWorkspaceBilling } from './state_workspace_billing';

const initialState: StateWorkspaceBilling = {
  balances_map: new Map(),
  credit_transactions_map: new Map(),
  payment_transactions_map: new Map(),

  subscriptions_map: new Map(),
};

export const slice_workspace_billing = createSlice({
  name: ENUM__redux_slice.WORKSPACE_BILLING,
  initialState,
  reducers: {
    balance_upsert: init_local_workspace_billing_balance_upsert,
    balance_delete: init_local_workspace_billing_balance_delete,

    subscriptions_upsert: init_local_billing_workspace_subscriptions_upsert,
    subscriptions_delete: init_local_workspace_billing_subscriptions_delete,

    credits_transactions_upsert: init_local_workspace_billing_credits_transactions_upsert,
    payment_transactions_upsert: init_workspace_local_billing_payment_transactions_upsert,
  },
  extraReducers: builder => {
    init_remote_stripe_checkout_session_create(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
